// Public token for demo purposes - replace with your own token for production
const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoibWFudXF0IiwiYSI6ImNtYXpiaTFvYTBpdjkybHM2cDh2ZDNsZWYifQ.ZNVYdYytEcJUWsVSnTt4lw';

export default MAPBOX_ACCESS_TOKEN;